module.exports = __webpack_public_path__ + "img/20_dice[8].ce1898bb.png";